/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_EditInputs */

const vi_aroma_sampling_edit = /** @type {(inputs: Aroma_Sampling_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa lần lấy hương`)
};

/**

* @param {Aroma_Sampling_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_edit = /** @type {((inputs?: Aroma_Sampling_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_edit(inputs)
});